module.exports = __webpack_public_path__ + "img/rca-close-button.3ec93d57.svg";